module.exports = __webpack_public_path__ + "img/logo_switch.52e95ebd.svg";